import { FETCH_TARIFF } from "../../actions/types";

const INITIAL_STATE = {};

const tariffReducer = (state = INITIAL_STATE, action) => {
  const { type, payload } = action;
  switch (type) {
    case FETCH_TARIFF:
      return {
        seasons: state.seasons,
        ...payload.data
      };
    default:
      return state;
  }
};

export default tariffReducer;



// WEBPACK FOOTER //
// ./src/reducers/helpers/tariff_reducer.js